import { del, get, post, postMultipart, put } from "../api_helper"
import * as url from "./url"

const getTrackings = ({ page, limit, keyword }) =>
  get(`${url.GET_TRACKINGS}?keyword=${keyword}&page=${page}&limit=${limit}`)
const getTracking = uid => get(url.GET_TRACKING + "/" + uid)
const getTrackingWithBookingAndContainer = (bookingNo, containerNo) =>
  get(
    url.GET_TRACKING_WITH_BOOKING_AND_CONTAINER +
      "?booking_no=" +
      bookingNo +
      "&container_no=" +
      containerNo
  )
const searchTrackings = keyword => get(url.SEARCH_TRACKINGS + "/" + keyword)
const postAddTracking = data => post(url.POST_TRACKING, data)
const putEditTracking = data => put(url.PUT_TRACKING, data)
const deleteTracking = data => del(url.DELETE_TRACKING, data)

export {
  putEditTracking,
  getTrackings,
  getTrackingWithBookingAndContainer,
  postAddTracking,
  deleteTracking,
  getTracking,
  searchTrackings,
}
